export const IMAGE_SILDER = "carousel image slider"
export const IMAGE_CLICK = "carousel image click"
export const LEFT_ARROW = "/icons/visual-nav-left-arrow.svg"
export const RIGHT_ARROW = "/icons/visual-nav-right.svg"
export const PLP = "plp"
